const initialState = {
  storedUser: null,
  error: null,
};

const mutations = {
  setStoredUser(state, user) {
    state.storedUser = user;
  },
  setError(state, error) {
    state.error = error;
  },
};

const actions = {
  storeUser({ commit }, user) {
    try {
      commit('setStoredUser', user);
    } catch (ex) {
      commit('setError', ex);
    }
  },
  clearStoredUser({ commit }) {
    commit('setStoredUser', null);
  },
};

export default {
  namespaced: true,
  state: initialState,
  mutations,
  actions,
};
